/*
 * Usage:
 * syntax: <input oly-move-focus="target"/>
 * target: value of the name attribute of the input to be tabbed to (required as getting the 'next' element is complicated)
 *
 * example 1: The following will tab to an input with id 'input-box' when a checkbox is ticked
 *          <input type="checkbox" oly-move-focus="idOfTarget"/>
 *
 * example 2: The following will tab to another element not in natural tab order on blur
 *          <input type="text" id="somebox" oly-move-focus="to-element-id" oly-move-focus-event="blur"/>
 *
 * exmaple 3: The following will focus the input element when tab key is press on this element
 *          <button oly-move-focus="my-element-to-focus" oly-move-focus-event="keydown keypress" oly-move-focus-key="tab" ></buttom>
 *
 * exmaple 3: The following will focus the input element when shift + tab key is press on this element
 *          <button oly-move-focus="my-element-to-focus" oly-move-focus-event="keydown keypress" oly-move-focus-key="shifttab" ></buttom>
 *
 * Doesn't work if the element needed to move focus to isn't visible.
 */


module.exports = function (focus) {
    return function (scope, elem, attr) {
        const event = attr.olyMoveFocusEvent || 'click';
        elem.on(event, function ($event) {
            if (scope.isEnabled && (!attr.olyMoveFocusKey ||
                (attr.olyMoveFocusKey === 'tab' && $event.keyCode === 9) ||
                (attr.olyMoveFocusKey === 'shifttab' && $event.shiftKey && $event.keyCode === 9)
                )) {
                    if (attr.olyMoveFocus.indexOf('.') === -1 && attr.olyMoveFocus.indexOf('#') === -1) {
                        focus(`#${attr.olyMoveFocus}`);
                    } else {
                        focus(attr.olyMoveFocus);
                    }
            }
        });
        const ifExpression = attr.olyMoveFocusIf;
        scope.$watch(ifExpression, function (value) {
            scope.isEnabled = value === undefined ? true : value;
        });
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/movefocus/movefocus-directive.js
 **/